import { Link } from "react-router-dom";
import scrollToTop from "../components/scrolltotop";
import { faqs } from "../data/faqdata";
import { Icon } from "@iconify/react";
const SubjectsPage = () => {
  return (
    <>
      <div className="courses-page-container">
        <img
          src="https://d1sq738v7irhr2.cloudfront.net/courses/blue-tris.webp"
          alt="tris"
          className="tris"
        />
        <div className="intro">
          <h1>11+ Success Starts Here</h1>
          <p>
            At Cito’s Learners we believe confident learners are successful
            learners. That’s why every 11+ course follows a clear, thoughtfully
            sequenced path, ensuring your child feels supported, challenged, and
            ready for their exams.
            <br />
            <br />
            From problem-solving in Maths to vocabulary mastery in English, and
            reasoning skills that sharpen the mind, our lessons are designed to
            nurture understanding and self-belief.
          </p>
        </div>

        <div className="wwt">
          <h3>What we teach</h3>
          <div className="subject-container">
            <div className="subject">
              <div className="subject-content">
                <h5>Mathematics</h5>
                <img
                  src="https://d1sq738v7irhr2.cloudfront.net/courses/wwt-maths.webp"
                  alt="subject img"
                />
                <Link
                  className="btn"
                  to="/subjects/maths"
                  onClick={scrollToTop}
                >
                  Learn more
                </Link>
              </div>
            </div>
            <div className="subject">
              <div className="subject-content">
                <h5>English</h5>
                <img
                  src="https://d1sq738v7irhr2.cloudfront.net/courses/wwt-eng.webp"
                  alt="subject img"
                />
                <Link
                  className="btn"
                  to="/subjects/english"
                  onClick={scrollToTop}
                >
                  Learn more
                </Link>
              </div>
            </div>
            <div className="subject">
              <div className="subject-content">
                <h5>Verbal Reasoning</h5>
                <img
                  src="https://d1sq738v7irhr2.cloudfront.net/courses/wwt-vr.webp"
                  alt="subject img"
                />
                <Link
                  className="btn"
                  to="/subjects/verbal-reasoning"
                  onClick={scrollToTop}
                >
                  Learn more
                </Link>
              </div>
            </div>
            <div className="subject">
              <div className="subject-content">
                <h5>Non-Verbal Reasoning</h5>
                <img
                  src="https://d1sq738v7irhr2.cloudfront.net/courses/wwt-nvr.webp"
                  alt="subject img"
                />
                <Link
                  className="btn"
                  to="/subjects/non-verbal-reasoning"
                  onClick={scrollToTop}
                >
                  Learn more
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="hwt">
          <div className="sect1">
            <h3>How we teach</h3>
            <p>
              At Cito’s Learners, we believe the best learning happens when
              students can see, review, and apply what they’ve learned in
              multiple ways. That’s why we use three core tools designed to make
              every concept clear, memorable, and practical.
            </p>
          </div>
          <div className="sect2">
            <div className="feat">
              <div className="feat-content">
                <h4>
                  <span>1.</span>Lesson Presentations{" "}
                </h4>
                <p>
                  Our engaging presentations introduce new topics in a
                  structured, easy-to-follow format. They are designed to
                  capture attention, explain complex ideas simply, and provide a
                  solid foundation for each subject area.
                </p>
              </div>
            </div>
            <div className="feat">
              <div className="feat-content">
                <h4>
                  <span>2.</span>Tutorial sheets{" "}
                </h4>
                <p>
                  After each lesson, learners receive a concise summary sheet
                  that distills the key points from the presentation. These
                  sheets make it easy to review essential information quickly,
                  making them perfect for revision or catching up.
                </p>
              </div>
            </div>
            <div className="feat">
              <div className="feat-content">
                <h4>
                  <span>3.</span>Worksheets{" "}
                </h4>
                <p>
                  To reinforce understanding, every topic includes multiple
                  worksheets filled with practice questions and activities. They
                  are ideal for homework, classwork, or extra revision, helping
                  students master concepts through hands-on learning.
                </p>
              </div>
            </div>
          </div>
          <p>
            Together, these tools ensure that every learner not only understands
            the material but can confidently apply it in any context.
          </p>
        </div>
        <div className="faq-sect" id="faq-sect">
          <h3>FAQs</h3>
          <div className="faq-list">
            {faqs.map((faq) => (
              <div key={faq.id} className="faq-item">
                <Icon icon="pepicons-pop:question" className="icon" />
                <div className="text">
                  <h5 className="faq-question">{faq.question}</h5>
                  <p className="faq-answer">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="faq-curved-bottom">
          <video
            alt="ani"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            disablePictureInPicture
            controlsList="nodownload nofullscreen noremoteplayback"
          >
            <source
              src="https://d1sq738v7irhr2.cloudfront.net/animations/Hammock.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </>
  );
};

export default SubjectsPage;
